import { TabEnum } from 'Common/Constants/Enumeration/TruckRouteEnum';
import * as types from './types';

const INITIAL_STATE = {
  selectedTab: TabEnum.TruckRoute,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.TRUCK_ROUTE_SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/settings/reducer.js